<template>
      <div class="hl-wid ww3 adm-list">
        <ul class="tab-like">
          <li class="head">
            <ul>
              <li class="title-only" v-on:click.prevent="toggleSort('title')">
                <span>Title</span>
                <a class="s-inc" :class="{active: sort.title===true}"></a>
                <a class="s-dec" :class="{active: sort.title===false}"></a>
              </li>
              <li class="author" v-if="entity=='User'">
                <span>Admin</span>
              </li>
              <li class="author" v-if="entity=='User'">
                <span>Subscription</span>
              </li>
            </ul>
          </li>
          <template v-for="(item, ii) in items" v-if="item.parent==null">
            <li>
              <ul>
                <li class="title-only" v-if="entity!='User'"><a href="" v-on:click.prevent="select(ii)">{{ item.title }}</a></li>
                <li class="title-only" v-else><a href="" v-on:click.prevent="select(ii)">{{ "#"+(ii+1)+" "+item.firstname+" "+item.lastname }}</a></li>
                <li class="author" v-if="entity=='User'">{{ item.admin?("Yes, "+(item.videoCount || 0)+" video(s)"):"No" }}</li>
                <li class="author" v-if="entity=='User'">{{ item.activePayment?item.activePayment.endDate:"No" }}</li>
                <li class="remove"><a v-if="!item.videoCount && !item.package" href="" v-on:click.prevent="doRemove(ii)">remove</a></li>
              </ul>
            </li>
            <template v-for="(item2, i2) in item.children">
              <li class="subitem subitem-2">
                <ul>
                  <li class="title-only" v-if="entity!='User'"><a href="" v-on:click.prevent="select(i2, item.children)">{{ item2.title }}</a></li>
                  <li class="title-only" v-else><a href="" v-on:click.prevent="select(i2, item.children)">{{ "#"+(ii+1)+" "+item2.firstname+" "+item2.lastname }}</a></li>
                  <li class="author" v-if="entity=='User'">{{ item2.admin?("Yes, "+(item2.videoCount || 0)+" video(s)"):"No" }}</li>
                  <li class="author" v-if="entity=='User'">{{ item2.activePayment?item2.activePayment.endDate:"No" }}</li>
                  <li class="remove"><a v-if="!item2.videoCount && !item2.package" href="" v-on:click.prevent="doRemove(i2, item.children)">remove</a></li>
                </ul>
              </li>
              <template v-for="(item3, i3) in item2.children">
                <li class="subitem subitem-3">
                  <ul>
                    <li class="title-only" v-if="entity!='User'"><a href="" v-on:click.prevent="select(i3, item2.children)">{{ item3.title }}</a></li>
                    <li class="title-only" v-else><a href="" v-on:click.prevent="select(i3, item2.children)">{{ "#"+(ii+1)+" "+item3.firstname+" "+item3.lastname }}</a></li>
                    <li class="author" v-if="entity=='User'">{{ item3.admin?("Yes, "+(item3.videoCount || 0)+" video(s)"):"No" }}</li>
                    <li class="author" v-if="entity=='User'">{{ item3.activePayment?item3.activePayment.endDate:"No" }}</li>
                    <li class="remove"><a v-if="!item3.videoCount && !item3.package" href="" v-on:click.prevent="doRemove(i3, item2.children)">remove</a></li>
                  </ul>
                </li>
              </template>
            </template>
          </template>
        </ul>
      </div>
</template>

<script>
import api from './api';
export default {
  props: ["entity"],
  data: ()=>({
    items: [],
    sort: {title: null},
  }),
  computed: {
  },
  created() {
    this.listItems();
  },
  methods: {
    toggleSort(column) {
      if (this.sort[column]===null)
        this.sort[column]=true;
      else if (this.sort[column]===true)
        this.sort[column]=false;
      else if (this.sort[column]===false)
        this.sort[column]=null;
    },
    async listItems() {
      var items=(await api.list(this.entity)).items;
//       if (this.entity=="User") {
//         items.sort((a,b)=>{
//           if (a.firstname<b.firstname) return -1;
//           if (a.firstname>b.firstname) return 1;
//           if (a.lastname<b.lastname) return -1;
//           if (a.lastname>b.lastname) return 1;
//           return 0;
//         });
//       }
      for(var item of items) {
        item.children=[];
        for(var item2 of items)
          if (item2.parent==item.id)
            item.children.push(item2);
      }
      this.items=items;
    },
    select(index, items) {
      var items=items || this.items;
      this.$emit("select", items[index]);
    },
    doRemove(index, list) {
      list=list || this.items;
      if (!confirm("Are you sure?"))
        return;
      if (i!=-1)
        this.$emit("remove", items.splice(i, 1)[0]);
    },
  }
}
</script>
